import styled from 'styled-components';
import MaterialTooltip from '@mui/material/Tooltip';
export const StyledTooltip = styled(MaterialTooltip) `
  max-width: ${({ theme }) => theme.spacing(29)};
  white-space: normal;
`;
